<template>
  <b-alert
    v-if="display"
    variant="primary"
    show
    dismissible
    class="gid-a2hs__alert fixed-bottom rounded-0 mb-0 p-0"
  >
    <div @click="addToHomeScreen" class="gid-a2hs__wrapper">
      <div class="clearfix">
        <img
          src="/icons/gid-logo-circle.svg"
          :alt="appName"
          class="gid-a2hs__icon"
        />
        <div class="gid-a2hs__text">{{ $t('pwa.a2hs', { appName }) }}</div>
      </div>
      <b-collapse
        v-if="isIOSSafari"
        :visible="iOSIntructionsVisible"
        class="gid-a2hs__ios"
      >
        <b-card class="text-body">
          <i18n path="pwa.ios.intro" tag="span">
            <strong slot="appName">{{ appName }}</strong>
          </i18n>
          <hr class="gid-a2hs__hr" />
          <div class="clearfix">
            <img
              src="/icons/ios-a2hs-share.svg"
              :alt="$t('pwa.ios.share-btn')"
              class="gid-a2hs__icon"
            />
            <i18n path="pwa.ios.step-1" tag="p" class="gid-a2hs__text pt-1">
              <strong slot="shareButton">
                '{{ $t('pwa.ios.share-btn') }}'
              </strong>
            </i18n>
          </div>
          <div class="clearfix">
            <img
              src="/icons/ios-a2hs-home.svg"
              :alt="$t('pwa.ios.a2hs-btn')"
              class="gid-a2hs__icon"
            />
            <i18n path="pwa.ios.step-2" tag="p" class="gid-a2hs__text mb-0">
              <strong slot="A2HSButton">'{{ $t('pwa.ios.a2hs-btn') }}'</strong>
            </i18n>
          </div>
        </b-card>
      </b-collapse>
    </div>
  </b-alert>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
  props: {
    appName: {
      type: String,
      default: 'Get It Done',
    },
  },
  data() {
    return {
      deferredPrompt: null,
      display: false,
      appInstalled: false,
      iOSIntructionsVisible: false,
    };
  },
  computed: {
    inApp() {
      return (
        window.navigator.standalone == true || // iOS Safari
        window.matchMedia('(display-mode: standalone)').matches
      ); // Androind Chrome
    },
    isIOSSafari() {
      return (
        (/iPad|iPhone|iPod/.test(window.navigator.platform) || // normal iOS
          (window.navigator.platform === 'MacIntel' &&
            window.navigator.maxTouchPoints > 1)) && // iOS 13+ iPad
        !window.MSStream && // not MIcrosoft IE
        !/CriOS/.test(window.userAgent)
      ); // not iOS Chrome
    },
    promptSupported() {
      return 'onbeforeinstallprompt' in window;
    },
  },
  created() {
    if (!this.inApp) {
      if (this.promptSupported && isMobile) {
        window.addEventListener('beforeinstallprompt', (e) => {
          // Prevent Chrome 67 and earlier from automatically showing the prompt
          e.preventDefault();
          // Stash the event so it can be triggered later.
          this.deferredPrompt = e;
          if (!this.appInstalled) {
            this.display = true;
          }
        });
        window.addEventListener('appinstalled', () => {
          this.appInstalled = true;
          this.display = false;
        });
      } else if (this.isIOSSafari) {
        this.display = true;
      }
    }
  },
  methods: {
    addToHomeScreen() {
      if (this.promptSupported) {
        this.display = false;
        this.deferredPrompt.prompt(); // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          this.gaTrackA2HAction({ event_label: choiceResult.outcome });
          this.deferredPrompt = null;
        });
      } else if (this.isIOSSafari) {
        this.iOSIntructionsVisible = !this.iOSIntructionsVisible;
      }
    },
    gaTrackA2HAction({ event_label }) {
      this.$gtag.event('A2HS', {
        event_category: 'PWA',
        event_label,
      });
    },
  },
};
</script>

<style lang="scss">
.gid-a2hs {
  &__wrapper {
    padding: 0.75rem 4rem 0.75rem 1.25rem;
    cursor: pointer;
  }
  &__icon {
    width: 1.6rem;
    float: left;
  }
  &__text {
    padding-left: 2rem;
  }
  &__ios {
    margin-top: 1rem;
    margin-right: -2.75rem;
  }
  &__hr {
    border-top-color: rgba($color: #000000, $alpha: 0.125) !important;
  }
}
</style>
